import config from "@/config"
import http from "@/utils/request"
export default {
	SavePaySettlementParam: {
	    url: `${config.API_URL}/PaySettlementParam/SavePaySettlementParam`,
	    name: "当面付",
	    post: async function (data) {
	        return await http.post(this.url, data, {
	            headers: {
	                //'response-status': 401
	            }
	        });
	    }
	},
	GetPaySettlementParam: {
	    url: `${config.API_URL}/PaySettlementParam/GetPaySettlementParam`,
	    name: "当面付",
	    post: async function (data) {
	        return await http.post(this.url, data, {
	            headers: {
	                //'response-status': 401
	            }
	        });
	    }
	},
}
